import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";

class PortfolioV1 extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";

    return (
      <div className="ltn__gallery-area mb-120">
        <div className="container">
          {/* (ltn__gallery-info-hide) Class for 'ltn__gallery-item-info' not showing */}
          <div className="ltn__gallery-active row ltn__gallery-style-2 ltn__gallery-info-hide---">
            <div className="ltn__gallery-sizer col-1" />
            {/* gallery-item */}
            <div className="ltn__gallery-item filter_category_3 col-lg-4 col-sm-6 col-12">
              <div className="ltn__gallery-item-inner">
                <div className="ltn__search-by-place-item">
                  <div className="search-by-place-img">
                    <Link to="/project-details">
                      <img
                        src={publicUrl + "assets/img/product-3/1.jpg"}
                        alt="#"
                      />
                    </Link>
                    <div className="search-by-place-badge">
                      <ul>
                        <li>Completed</li>
                      </ul>
                    </div>
                  </div>
                  <div className="search-by-place-info">
                    <h6>
                      <Link to="/contact">Ahmedabad</Link>
                    </h6>
                    <h4 style={{ color: "#ff5b3b" }}>
                      <Link to="/project-details">Mission District Area</Link>
                    </h4>
                    <div className="search-by-place-btn">
                      <Link to="/project-details">
                        View More <i className="flaticon-right-arrow" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
			<div className="ltn__gallery-item filter_category_3 col-lg-4 col-sm-6 col-12">
              <div className="ltn__gallery-item-inner">
                <div className="ltn__search-by-place-item">
                  <div className="search-by-place-img">
                    <Link to="/project-details">
                      <img
                        src={publicUrl + "assets/img/product-3/1.jpg"}
                        alt="#"
                      />
                    </Link>
                    <div className="search-by-place-badge">
                      <ul>
                        <li>Completed</li>
                      </ul>
                    </div>
                  </div>
                  <div className="search-by-place-info">
                    <h6>
                      <Link to="/contact">Ahmedabad</Link>
                    </h6>
                    <h4 style={{ color: "#ff5b3b" }}>
                      <Link to="/project-details">Mission District Area</Link>
                    </h4>
                    <div className="search-by-place-btn">
                      <Link to="/project-details">
                        View More <i className="flaticon-right-arrow" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
			<div className="ltn__gallery-item filter_category_3 col-lg-4 col-sm-6 col-12">
              <div className="ltn__gallery-item-inner">
                <div className="ltn__search-by-place-item">
                  <div className="search-by-place-img">
                    <Link to="/project-details">
                      <img
                        src={publicUrl + "assets/img/product-3/1.jpg"}
                        alt="#"
                      />
                    </Link>
                    <div className="search-by-place-badge">
                      <ul>
                        <li>Completed</li>
                      </ul>
                    </div>
                  </div>
                  <div className="search-by-place-info">
                    <h6>
                      <Link to="/contact">Ahmedabad</Link>
                    </h6>
                    <h4 style={{ color: "#ff5b3b" }}>
                      <Link to="/project-details">Mission District Area</Link>
                    </h4>
                    <div className="search-by-place-btn">
                      <Link to="/project-details">
                        View More <i className="flaticon-right-arrow" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
			<div className="ltn__gallery-item filter_category_3 col-lg-4 col-sm-6 col-12">
              <div className="ltn__gallery-item-inner">
                <div className="ltn__search-by-place-item">
                  <div className="search-by-place-img">
                    <Link to="/project-details">
                      <img
                        src={publicUrl + "assets/img/product-3/1.jpg"}
                        alt="#"
                      />
                    </Link>
                    <div className="search-by-place-badge">
                      <ul>
                        <li>Completed</li>
                      </ul>
                    </div>
                  </div>
                  <div className="search-by-place-info">
                    <h6>
                      <Link to="/contact">Ahmedabad</Link>
                    </h6>
                    <h4 style={{ color: "#ff5b3b" }}>
                      <Link to="/project-details">Mission District Area</Link>
                    </h4>
                    <div className="search-by-place-btn">
                      <Link to="/project-details">
                        View More <i className="flaticon-right-arrow" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
			<div className="ltn__gallery-item filter_category_3 col-lg-4 col-sm-6 col-12">
              <div className="ltn__gallery-item-inner">
                <div className="ltn__search-by-place-item">
                  <div className="search-by-place-img">
                    <Link to="/project-details">
                      <img
                        src={publicUrl + "assets/img/product-3/1.jpg"}
                        alt="#"
                      />
                    </Link>
                    <div className="search-by-place-badge">
                      <ul>
                        <li>Completed</li>
                      </ul>
                    </div>
                  </div>
                  <div className="search-by-place-info">
                    <h6>
                      <Link to="/contact">Ahmedabad</Link>
                    </h6>
                    <h4 style={{ color: "#ff5b3b" }}>
                      <Link to="/project-details">Mission District Area</Link>
                    </h4>
                    <div className="search-by-place-btn">
                      <Link to="/project-details">
                        View More <i className="flaticon-right-arrow" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
			<div className="ltn__gallery-item filter_category_3 col-lg-4 col-sm-6 col-12">
              <div className="ltn__gallery-item-inner">
                <div className="ltn__search-by-place-item">
                  <div className="search-by-place-img">
                    <Link to="/project-details">
                      <img
                        src={publicUrl + "assets/img/product-3/1.jpg"}
                        alt="#"
                      />
                    </Link>
                    <div className="search-by-place-badge">
                      <ul>
                        <li>Completed</li>
                      </ul>
                    </div>
                  </div>
                  <div className="search-by-place-info">
                    <h6>
                      <Link to="/contact">Ahmedabad</Link>
                    </h6>
                    <h4 style={{ color: "#ff5b3b" }}>
                      <Link to="/project-details">Mission District Area</Link>
                    </h4>
                    <div className="search-by-place-btn">
                      <Link to="/project-details">
                        View More <i className="flaticon-right-arrow" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PortfolioV1;
